// src/pages/AboutPage.tsx - Valuate About Us Page
import React from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Button,
  useTheme,
  alpha,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

const AboutPage: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const sectionStyle = {
    mb: 4,
  };

  const headingStyle = {
    fontWeight: 600,
    mb: 2,
    color: theme.palette.text.primary,
  };

  const textStyle = {
    color: theme.palette.text.secondary,
    lineHeight: 1.8,
    mb: 2,
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: theme.palette.mode === 'dark'
          ? 'linear-gradient(180deg, #0F172A 0%, #1E293B 100%)'
          : 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
        py: 6,
      }}
    >
      <Container maxWidth="md">
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/')}
          sx={{ mb: 4 }}
        >
          Back to Home
        </Button>

        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 3,
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          }}
        >
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 4 }}>
            About Valuate
          </Typography>

          <Box sx={sectionStyle}>
            <Typography variant="h5" sx={headingStyle}>
              Our Mission
            </Typography>
            <Typography sx={textStyle}>
              Valuate provides AI-powered hotel valuation tools designed to help investors,
              owners, and professionals make informed decisions in the hospitality real estate market.
              We combine advanced artificial intelligence with established valuation methodologies
              to deliver comprehensive property analysis.
            </Typography>
          </Box>

          <Box sx={sectionStyle}>
            <Typography variant="h5" sx={headingStyle}>
              What We Do
            </Typography>
            <Typography sx={textStyle}>
              Our platform leverages multi-agent AI systems to analyze financial documents,
              market conditions, and property data. We offer multiple valuation approaches including
              discounted cash flow analysis, capitalization rate analysis, sales comparison,
              cost approach, revenue multiples, and gross rent multiplier methods.
            </Typography>
            <Typography sx={textStyle}>
              Valuate processes various document formats including Excel spreadsheets, PDFs,
              and images to extract relevant financial data. Our market intelligence features
              provide competitive analysis and pricing insights to support investment decisions.
            </Typography>
          </Box>

          <Box sx={sectionStyle}>
            <Typography variant="h5" sx={headingStyle}>
              Important Notice
            </Typography>
            <Typography sx={textStyle}>
              Valuate is a technology platform that provides analytical tools and data processing
              capabilities. The valuations and analyses generated by our platform are for
              informational purposes only and should not be construed as financial, investment,
              or legal advice. Users should conduct their own due diligence and consult with
              qualified professionals before making investment decisions.
            </Typography>
          </Box>

          <Box sx={sectionStyle}>
            <Typography variant="h5" sx={headingStyle}>
              Contact
            </Typography>
            <Typography sx={textStyle}>
              For questions about our platform or services, please use the contact form
              available on our website.
            </Typography>
          </Box>

          <Typography
            variant="body2"
            sx={{ color: theme.palette.text.disabled, mt: 4 }}
          >
            Last updated: January 2026
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default AboutPage;
